
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* 事務所情報 */}
          <div>
            <h3 className="text-xl font-bold mb-4">冨田・島岡法律事務所</h3>
            <p className="text-gray-300 text-sm mb-4">
              愛知・岐阜・三重・静岡の負動産処分に対応
            </p>
            <p className="text-gray-400 text-sm">
              〒460-0008<br />
              愛知県名古屋市中区栄2-2-17<br />
              名古屋情報センタービル6階
            </p>
          </div>

          {/* サービス */}
          <div>
            <h3 className="text-xl font-bold mb-6">サービス</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/#property-types" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  負動産処分
                </Link>
              </li>
              <li>
                <Link to="/kyoyu-meigi" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  共有名義・相続未分割
                </Link>
              </li>
              <li>
                <Link to="/nouchi" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  農地処分
                </Link>
              </li>
              <li>
                <Link to="/#pricing" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  料金案内
                </Link>
              </li>
            </ul>
          </div>

          {/* コラム */}
          <div>
            <h3 className="text-xl font-bold mb-6">コラム</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/blog/sanrin-syobun-5-houhou" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  山林を処分する5つの方法
                </Link>
              </li>
              <li>
                <Link to="/blog/nouchi-souzoku-5-sentakushi" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  農地を相続したくない場合
                </Link>
              </li>
              <li>
                <Link to="/blog/kokko-kizon-shinsei-houhou" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  国庫帰属制度の申請方法
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer flex items-center">
                  コラム一覧
                  <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </li>
            </ul>
          </div>

          {/* サイトマップ */}
          <div>
            <h3 className="text-xl font-bold mb-6">サイトマップ</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  トップページ
                </Link>
              </li>
              <li>
                <Link to="/#problems" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  よくあるお悩み
                </Link>
              </li>
              <li>
                <Link to="/#process" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  解決までの流れ
                </Link>
              </li>
              <li>
                <Link to="/#office" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  事務所案内
                </Link>
              </li>
              <li>
                <Link to="/#contact" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 cursor-pointer">
                  相談予約
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2024 冨田・島岡法律事務所. All rights reserved. | 
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-orange-400 ml-1 cursor-pointer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
